module.exports = __webpack_public_path__ + "static/media/parrot.3f0f40cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/parrot.svg
// module id = 65
// module chunks = 0